module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-offer-yellow-71187a.svg";